const md5 = require('js-md5')

module.exports = {
  data() {
    return {
      title: '安徽交控招标采购平台',
      needVerifyCode: false, // 是否需要验证码登录
      form: {
        account: '',
        password: '',
      },
      selectLabel: '招标人',
      options: [
        {
          label: '招标人',
          value: 1,
        },
        {
          label: '投标人',
          value: 2,
        },
      ],
    }
  },
  methods: {
    login() {
      if (!this.form.account || !this.form.password) {
        this.$toast({
          message: '用户名密码不能为空',
          position: 'bottom',
        })
        return
      }
      this.$request
        .post(
          '/transformToAfter/guotou-auth/oauth/token',
          {
            username: this.form.account,
            password: md5(this.form.password),
            grant_type: 'password',
            userType: 1,
            client_id: 'test_beijing',
            client_secret: 'test',
            caType: 1,
          },
          { showLoading: true },
        )
        .then((res) => {
          if (res.access_token) {
            this.$store.commit('setToken', res.access_token)
            this.$router.push({ name: 'Home' })
          } else {
            this.$errorInfo(res.errMessage)
          }
        })
    },
  },
}
